export const radiuses = {
  m: '0.25rem',
  l: '0.5rem',
  xl: '1rem',
  xxl: '2rem',
} as const;
export type Radiuses = typeof radiuses;
